import { ProfitLoss } from '../../ProfitLoss';
import React from 'react';
import { StrategyNFTCollection } from './types';
import { useTranslation } from 'react-i18next';
import { CustomNumber } from '../../CustomNumber/CustomNumber';
import { calculateRoi } from './helper';

interface NFTCollectionCardProps {
  strategyNftCollection: StrategyNFTCollection;
  width: number;
  onClick: () => void;
}

const NFTCollectionCard: React.FC<NFTCollectionCardProps> = ({
  strategyNftCollection,
  width,
  onClick,
}) => {
  const { t } = useTranslation();

  const { bannerImageUrl, imageUrl, name } = strategyNftCollection.collection;

  const { tokenCount } = strategyNftCollection;

  const collectionValues = calculateRoi(strategyNftCollection);

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl border border-grey-10 dark:border-grey-70 overflow-hidden hover:border-grey-50 shadow-light cursor-pointer"
    >
      <div className={width === 1 ? 'h-28' : 'h-32'}>
        {bannerImageUrl ? (
          <img
            src={bannerImageUrl}
            alt="nft wallpaper"
            loading={'lazy'}
            className="object-cover w-full h-full"
          />
        ) : (
          <div className={'bg-black w-full h-full'} />
        )}
      </div>
      <div className="dark:bg-grey-90 dark:text-grey-30">
        <div className="flex w-full justify-center transform -translate-y-1/2">
          <img
            src={imageUrl}
            alt="nft avatar"
            className="w-10 h-10 rounded-full object-cover"
          />
        </div>
        <div>
          <p className="text-center text-base font-medium truncate">{name}</p>
          <p className="text-center text-grey-70 dark:text-grey-50 text-sm">
            {t('widget.nft.itemsCount', { value: tokenCount })}
          </p>
        </div>
        <div className="flex justify-between p-4 -mt-3">
          <div>
            <p className="text-grey-50 text-xs">{t('widget.nft.totalValue')}</p>
            <div className="flex items-center gap-2">
              <span className="font-semibold text-sm">
                <CustomNumber
                  displayType={'text'}
                  value={collectionValues.usd}
                />
              </span>
              <div className="flex items-center gap-1">
                <img src="/icons/eth.svg" alt="Ethereum icon" />
                <span className="text-sm text-grey-70 dark:text-grey-50">
                  <CustomNumber
                    displayType={'text'}
                    value={collectionValues.eth}
                    decimalScale={2}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-end">
            <p className="text-grey-50 text-xs">{t('widget.nft.ROI')}</p>
            <div className="flex gap-2 text-sm">
              <CustomNumber displayType={'text'} value={collectionValues.roi} />
              <ProfitLoss
                displayType={'text'}
                percentage={collectionValues.roiPercentage}
                size={'small'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NFTCollectionCard;
